export default __webpack_public_path__ + "assets/calendar-plus-component.42f8a31e.svg";